module.exports = __webpack_public_path__ + "static/media/devalue-batch-sample.cc22fbc1.csv";